<template>
    <van-row v-html="this.list.content"> </van-row>
  </template>
  <script>
  export default {
    data() {
      return {
        list: {},
      };
    },
  
    mounted() {
    },
    created() {
      this.getPrivacy();
        
    },
    methods: {
      getPrivacy() {
        this.axios({
          method: "post",
          url: "api/myPage/searchByTitle",
          data: {
            title: "鸿蒙隐私政策",
          },
        }).then((res) => {
          if (res.data.code == 200) {
            this.list = res.data.data
          }
        });
      },
    },
  };
  </script>
  <style lang="less" scoped>
  /deep/p {
    text-align: left;
    font-size: 16px;
  }
  /deep/.ql-align-center {
    margin-top: 0.625rem;
    text-align: center;
  }
  /deep/ u {
    word-break: break-all;
  }
  .van-row {
    box-sizing: border-box;
    padding: 0.3125rem;
  }
  </style>


// WEBPACK FOOTER //
// src/components/hmprivacy.vue